export const SEARCH_API_BASE_URL = "https://api.mapbox.com/search/v1";
export const SEARCH_API_MAX_LIMIT = 10;
export const SEARCH_TEXT_MAX_LENGTH = 120;
export const SEARCH_PARAM_COUNTRY = "NZ";
export const SEARCH_PARAM_LANGUAGE = "en";
export const SEARCH_PARAM_FORWARD_GEOCODE_TYPES = ["address", "locality", "poi", "street"];
export const SEARCH_PARAM_REVERSE_GEOCODE_TYPE = "address";
